import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from './AuthContext';
import type { Role } from './authStore';
import AccessDeniedPage from '../pages/AccessDeniedPage';

interface RequireAuthProps {
  allowedRoles?: Role[];
  children: ReactNode;
}

export default function RequireAuth({ allowedRoles, children }: RequireAuthProps) {
  const { session } = useAuth();

  if (!session) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(session.role)) {
    return <AccessDeniedPage />;
  }

  return <>{children}</>;
}
